import React, { useEffect, useState } from 'react';
import { Bubble } from 'tea-component';
import { getPlatformName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import classNames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi';
import { StatusBubbleContent } from '@intelligence/components/DataSourceComponents';
import './index.scss';
interface FirstRowEditionType {
  name: string;
  isUnPublished: boolean;
  isInactive?: boolean;
  platform: string;
  imgSrc: string;
  onClick?: any;
}

export default function FirstRowEdition(params: FirstRowEditionType) {
  const { name, isUnPublished, isInactive = false, platform, imgSrc, onClick } = params;
  const { formatMessage } = useIntl(); // 中英切换方法
  const getPlatformIcon = (platform: string) => {
    let iconType = 'a-select-icon';
    if (platform == 'ios') {
      iconType = 'a-select-icon';
    }
    if (platform == 'android') {
      iconType = 'video-icon';
    }
    return iconType;
  };

  return (
    <div
      className={classNames({
        'dbi-table-edition-firstrow': true,
        'dbi-table-edition-firstrow-opacity': isUnPublished,
      })}
      onClick={() => {
        if (onClick instanceof Function) {
          onClick();
        }
      }}
    >
      {platform ? (
        <SvgIcon
          type={getPlatformIcon(platform)}
          className="dbi-table-edition-firstrow-icon"
        />
      ) : null}
      {imgSrc && (
        <img src={imgSrc} alt="" className="dbi-table-edition-firstrow-img" />
      )}
      <span className="dbi-table-edition-firstrow-text">
        {platform ? `${name}(${getPlatformName(platform)})` : name}
      </span>
      {isInactive ? (
        <Bubble dark content={<StatusBubbleContent descId="dbi_inactive_hover" />}>
          <div className="dbi-details-popover_tip">{formatMessage({ id: 'dbi_inactive' })}</div>
        </Bubble>
      ) : null}
      {isUnPublished ? (
        <Bubble dark content={<StatusBubbleContent descId="dbi_offline_hover" />}>
          <div
            className="dbi-details-popover_tip dbi-details-popover_tip--offline"
            style={isInactive ? { marginLeft: -6 } : undefined}
          >
            {formatMessage({ id: 'dbi_offline' })}
          </div>
        </Bubble>
      ) : null}
    </div>
  );
}
